import { Injectable } from '@angular/core';

import { UserService } from '@frontend/sports/user/feature';

import { NotLoggedInPreCheckError } from '../../../errors/pre-check/not-logged-in-pre-check-error';

@Injectable()
export class NotLoggedInValidator {
    constructor(private userService: UserService) {}

    validate(): NotLoggedInPreCheckError[] {
        return !this.userService.isAuthenticated ? [new NotLoggedInPreCheckError()] : [];
    }
}
